module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "infos"
    }
  }, [_c('h2', [_vm._v(" Informations pratiques")]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Où nous trouver ")]), _vm._v(" "), _c('p', [_vm._v(" HOPITAL "), _c('strong', [_vm._v("VETERINAIRE")])]), _vm._v(" "), _c('p', [_vm._v(" Carrer Sant Jordi n°37")]), _vm._v(" "), _c('p', [_vm._v(" AD200 "), _c('strong', [_vm._v("PAS DE LA CASE")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("ANDORRE")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.google.fr/maps/place/Hospital+Veterinari/@42.5433291,1.7292353,17z/data=!3m1!4b1!4m5!3m4!1s0x12af7d8c7a8fdecb:0x9b2dad0f8b06fd2e!8m2!3d42.5433252!4d1.7314186",
      "target": "_blank"
    }
  }, [_vm._v("Voir carte")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Nos horaires ")]), _vm._v(" "), _c('p', [_vm._v("9h30-13h00 et 15h00-19h00")]), _vm._v(" "), _c('p', [_vm._v(" La "), _c('strong', [_vm._v("clinique")]), _vm._v(" est fermée les 01/01, 14/03, 8/09, 25/12")]), _vm._v(" "), _c('p', [_vm._v(" Les soins sur rendez-vous seulement ")]), _vm._v(" "), _c('p', [_vm._v(" Pour la chirurgie, les "), _c('strong', [_vm._v("animaux")]), _vm._v(" sont déposés le matin à 8h30\n        et récupérés à 16h")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Nous contacter ")]), _vm._v(" "), _c('p', [_vm._v(" (FR) +33681459871 ")]), _vm._v(" "), _c('p', [_vm._v(" ("), _c('strong', [_vm._v("AND")]), _vm._v(") +376855536 ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:vetopas@andorra.ad",
      "target": "_blank"
    }
  }, [_vm._v("vetopas@andorra.ad")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66126e0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fr/Infos.vue
// module id = 137
// module chunks = 0